/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var nav = __webpack_require__(4);
	    var placeholder = __webpack_require__(9);
	    var search = __webpack_require__(12);
	    var setUserInfo = __webpack_require__(17);
	
	    setUserInfo();
	    search.addSearchEvent();
	    nav.control.init();
	    nav.handleNav();
	    placeholder.init();
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var Config = __webpack_require__(3);
	
	    var lazyload = {
	        init: function init(opt) {
	            var that = this;
	            var op = {
	                anim: true,
	                root: null //jquery对象,配置后查找当前对象下的img标签
	            };
	            $.extend(op, opt);
	            that.img.init(op);
	        },
	        img: {
	            init: function init(n) {
	                function inViewport(el) {
	                    var scroll_top = void 0;
	                    if (document.documentElement && document.documentElement.scrollTop) {
	                        scroll_top = document.documentElement.scrollTop;
	                    } else if (document.body) {
	                        scroll_top = document.body.scrollTop;
	                    }
	
	                    var top = scroll_top;
	                    var btm = scroll_top + document.documentElement.clientHeight;
	                    var elTop = $(el).offset().top;
	
	                    var elBtm = elTop + $(el).height();
	                    return elBtm >= top - 300 && elTop <= btm + 300;
	                }
	
	                $(window).scroll(function () {
	                    var lazyObj = $("img.lazy[data-original]").not("[loaded]");
	                    if (n.root != null) {
	                        lazyObj = n.root.find("img.lazy[data-original]").not("[loaded]");
	                    }
	                    lazyObj.each(function (index, node) {
	                        var $this = $(this);
	                        if ($this.hasClass('hideImg')) {
	                            return;
	                        }
	                        if (!inViewport(this)) {
	                            return;
	                        }
	                        act($this);
	                    });
	                }).trigger('scroll');
	
	                function act(_self) {
	                    var img = new Image();
	                    var original = _self.attr('data-original');
	
	                    if (original.indexOf("360buyimg") > -1) {
	                        if (Config.isSupportWebP && _self.hasClass("useWebP")) {
	                            if (original.indexOf(".jpg") > 0) {
	                                original = original.replace(/.jpg$/, ".jpg!q90.webp");
	                            } else if (original.indexOf(".png") > 0) {
	                                original = original.replace(/.png$/, ".png.webp");
	                            }
	                        } else {
	                            original = original.replace(/.jpg$/, ".jpg!q90");
	                        }
	                    }
	
	                    img.onload = function () {
	                        _self.attr('src', original).removeClass('lazy');
	                        n.anim && _self.css({
	                            opacity: .2
	                        }).animate({
	                            opacity: 1
	                        }, 280);
	                    };
	                    try {
	                        if (original) {
	                            img.src = original;
	                        }
	                    } catch (error) {}
	
	                    _self.attr('loaded', true);
	                }
	            }
	        }
	    };
	    exports.fn = lazyload;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var Config = {
	        debug: false,
	        isSubmited: false,
	        isSupportWebP: false,
	        isIE: function isIE() {
	            //ie?
	            if (!!window.ActiveXObject || "ActiveXObject" in window) return true;else return false;
	        }
	    };
	
	    Config.serviceInterface = {
	        getTime: "//specials.jd.hk/getTime.do",
	        getTrackInfo: "//home.jd.hk/asyn/getTrackInfo.do",
	        getIdNumber: "//home.jd.hk/asyn/checkOrderIdCard.do",
	        confirmReceipt: "//home.jd.hk/asyn/confirmReceipt.do",
	        cancelOrder: "//home.jd.hk/asyn/cancelOrder.do",
	        deleteCoupon: "//home.jd.hk/asyn/delUserCoupon.do?",
	        getCouponCount: "//home.jd.hk/coupon/count.do",
	        getOrderState: "//club.jd.com/mycomments/getListOrderHandleState.action",
	        getOrderState_local: "//home.jd.hk/asyn/getOrderHandleState.do",
	        deleteOrder: "//home.jd.hk/asyn/recycleOrder.do",
	        cancelFollow: "//home.jd.hk/asyn/unfollow.do",
	        ajaxCancelFollowShop: "//home.jd.hk/asyn/unFollowByshopId.do",
	        getHistoricEmail: "//home.jd.hk/asyn/storeNotifyBaseInfo.do",
	        sendStoreNotifyEmail: "//home.jd.hk/asyn/storeNotify.do",
	        addToCart: "//cart.jd.com/gate.action",
	        loadShopSkus: "//diviner.jd.com/diviner",
	        getCitys: "//home.jd.hk/asyn/getCitys.do",
	        getCountries: "//home.jd.hk/asyn/getCountries.do",
	        getTowns: "//home.jd.hk/asyn/getTowns.do",
	        deleteAddressById: "//home.jd.hk/asyn/delAddressById.do",
	        updateAddress: "//home.jd.hk/asyn/updateAddress.do",
	        insertAddress: "//home.jd.hk/asyn/insertAddressInfo.do",
	        getAddressNameMap: "//home.jd.hk/asyn/getaddressNameMap.do",
	        setDefaultAddress: "//home.jd.hk/asyn/setDefaultAdress.do",
	        loadRecmdGoods: "//diviner.jd.com/diviner",
	        loadRecmdShops: "//home.jd.hk/asyn/getrecommendShopsByshopId.do",
	        getCommentsCnt: "//home.jd.hk/comment/count.do",
	        getCommentByguid: "//home.jd.hk/comment/getByGuid.do",
	        // getQiangNum: "//qiangsite.jd.com/qiangnum/mgets",
	        // getFoodMsProcess: "//qiangsite.jd.com/qiangnum/mgets",
	        getPromoById: "//grocer.jd.hk/getPromoById.do",
	        grocerAddCart: "//grocer.jd.hk/addCart.do",
	        getSkuPromoTag: "//grocer.jd.hk/getSkuPromoTag.do",
	        getShopPromoTag: "//grocer.jd.hk/getShopPromoTag.do",
	        getFollowingCnt: "//home.jd.hk/follow/count.do",
	        getPromotingskus: "//home.jd.hk/follow/getPromoProduct.do",
	        getCartNum: "//hongkong.jd.com/getCartNum.do",
	        getBrowserHistory: "//hongkong.jd.com/getBrowseHistory.do",
	        getCommentByskuIds: "//zy.jd.hk/getCommentCountBySkuId.html",
	        getTypeBySkuId: "//search.jd.hk/getTypeBySkuId.do",
	        saveIdCard: "/asyn/storeReceiverIdCard.do",
	        validateUploadName: "//home.jd.hk/clearanceUpload/validateUploadName.do",
	        idCardUploadSync: "//jdw.jd.hk/clearance/uploadStatus.do",
	        //getStockBySkuId: '//search.jd.hk/getStockBySkuId.do',
	        getCategory: "//search.jd.hk/getCategory.do",
	        getGoodRateBySkuId: "//zy.jd.hk/getGoodRateBySkuId.html",
	        delayReceipt: "//home.jd.hk/asyn/delayReceipt.do",
	        getComponentInfo: "//jicc-web.jd.com/api/component/getComponentInfo/pc",
	        uploadImage: "//jicc-web.jd.com/api/component/uploadImage/pc",
	        saveImage: "//jicc-web.jd.com/api/component/save/pc",
	        doGrant: "//home.jd.hk/asyn/idCardAuth/doGrant.do",
	        getStatus: "//home.jd.hk/asyn/idCardAuth/status.do",
	        getSupplyChainTrace: "//home.jd.hk/asyn/supplyChainTrace.do",
	
	        getOrderPerson: "//home.jd.hk/order/getPurchaserInfo.html",
	        getOrderEnterPerson: "//home.jd.hk/order/verifyPurchaserInfo.html",
	        getOrderPersonSend: "//home.jd.hk/order/submitPurchaserInfo.html",
	
	        getShopServer: "//chat1.jd.com/api/checkChat?",
	
	        //预售付款：定金阶段、全款阶段、尾款（不支持优惠券）
	        presaleOrderOne: "//trade.jd.hk/presale/getOrderCashierLink.action?",
	
	        //预售尾款支持优惠券
	        presaleOrderCoupon: "//trade.jd.hk/presale/end.action?",
	        //商户入驻
	        applyVender: "//www.jd.hk/cooperation/applySellerApplyResidence.do",
	        applyFacilitator: "//www.jd.hk/cooperation/applyFacilitatorResidence.do",
	        uploadFacilitator: "//www.jd.hk/cooperation/upload.do",
	        submitSuccess: "//www.jd.hk/cooperation/submitSuccess.do",
	        submitSuccessEn: "//www.jd.hk/cooperation/submitSuccessEn.do",
	        uploadFacilitatorFile: "//www.jd.hk/cooperation/uploadFile.do"
	
	    };
	
	    Config.validators = {
	        email: {
	            regExp: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	            errorMsg: "请填写正确的邮箱地址"
	        },
	        phoneNum: {
	            regExp: /^1[3|4|5|7|8]\d{9}$/,
	            errorMsg: "手机号码格式不正确"
	        },
	        idCard: {
	            regExp: /^(\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/,
	            errorMsg: "请填写正确的身份证号码"
	        },
	        staticPhone: {
	            regExp: /^((^[0-9 -]+$)|(1[34578]\d{9}))$/,
	            errorMsg: "请填写正确的固定电话"
	        },
	        receiver: {
	            errorMsg: "请填写正确的收货人"
	        },
	        validateAddressDetail: {
	            errorMsg: "详细地址不能为空"
	        },
	        money: {
	            regExp: /^\d+(\.\d+)?$/,
	            errorMsg: "金额格式不正确"
	        },
	        url: {
	            regExp: /^((https|http|ftp|rtsp|mms)?:\/\/)+[A-Za-z0-9]+\.[A-Za-z0-9]+[\/=\?%\-&_~`@[\]\':+!]*([^<>\"\"])*$/,
	            errorMsg: "链接格式不正确"
	        },
	        number: {
	            regExp: /^\d+$/,
	            errorMsg: "数字格式不正确"
	        }
	    };
	
	    module.exports = Config;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var lazyLoad = __webpack_require__(2);
	
	var handleNav = function handleNav() {
	    $("#categorys-2014").find(".dd-inner .item").bind("mouseenter", function (e) {
	        e.preventDefault();
	        $(this).addClass("hover").siblings().removeClass("hover");
	
	        $(this).find(".sub-menu .lazy").removeClass("hideImg");
	
	        var subObj = $(this).find(".sub-menu");
	        var offsetFocus = $("#categorys-2014 .dd").offset().top;
	        var itemOffsetTop = $(this).offset().top;
	        var moveY = itemOffsetTop - offsetFocus - 2;
	
	        subObj.css("top", -moveY);
	        lazyLoad.fn.init({ "root": $(this) });
	    });
	
	    $("#navitems-2014").bind("mouseenter", function (e) {
	        e.preventDefault();
	        unHover();
	    });
	
	    $("#categorys-2014").bind("mouseleave", function (e) {
	        e.preventDefault();
	        unHover();
	    });
	
	    function unHover() {
	        $("#categorys-2014").find(".dd-inner .item").removeClass("hover");
	    }
	};
	
	var control = {
	    init: function init() {
	        var self = this;
	        self.handleShop();
	        self.loadMenu();
	        self.changeRoot();
	    },
	    loadMenu: function loadMenu() {
	        var self = this;
	        $("#categorys-2014 .dd").remove();
	        $(".leaf-nav").remove();
	        $.ajax({
	            type: 'POST',
	            url: "//www.jd.hk/header/getData.do",
	            dataType: "jsonp",
	            success: function success(data) {
	                self.reunderNav(data);
	                self.hover();
	                handleNav();
	            }
	        });
	    },
	    reunderNav: function reunderNav(data) {
	        var self = this;
	
	        if (typeof queryParam != "undefined" && queryParam.keyword) {
	            $("#key").val(html_decode(queryParam.keyword)).attr("placeholder", data.indexTopSearchPlaceHolderText[0].text);
	        } else {
	            $("#key").val(data.indexTopSearchPlaceHolderText[0].text).attr("placeholder", data.indexTopSearchPlaceHolderText[0].text);
	        }
	
	        var tplNavMenu = __webpack_require__(5);
	        var navMenuHtml = self.render(data, tplNavMenu);
	        $("#categorys-2014 .dt").after(navMenuHtml);
	
	        var tplNavItem = __webpack_require__(6);
	        var navItemHtml = self.render(data, tplNavItem);
	        $("#navitems-2014").html(navItemHtml);
	
	        var tplHotKey = __webpack_require__(7);
	        var hotKeyHtml = self.render(data, tplHotKey);
	        $("#hotwords-2014").html(hotKeyHtml);
	
	        function html_decode(str) {
	            var s = "";
	            if (str.length == 0) return "";
	            s = str.replace(/&lt;/g, "<");
	            s = s.replace(/&gt;/g, ">");
	            s = s.replace(/&apos;/g, "\'");
	            s = s.replace(/&quot;/g, "\"");
	            s = s.replace(/&#92;/g, "\\");
	            s = s.replace(/&amp;/g, "&");
	            return s;
	        }
	    },
	    changeRoot: function changeRoot() {
	        $(".leaf-nav").each(function () {
	            $(this).insertAfter($("#nav-2014 .w"));
	        });
	    },
	    hover: function hover() {
	        $("#categorys-2014").unbind("mouseenter").bind("mouseenter", function (e) {
	            $(this).find(".dd").css("display", "block");
	            $(this).addClass("hover");
	        }).bind("mouseleave", function () {
	            $(this).find(".dd").css("display", "none");
	            $(this).removeClass("hover");
	        });
	
	        $("#categorys-2014 .dd").unbind("mouseenter").bind("mouseenter", function () {
	            $(this).css("display", "block");
	        }).bind("mouseleave", function () {
	            setTimeout(function () {
	                if ($("#categorys-2014").hasClass("hover")) {
	                    return false;
	                }
	                $(this).css("display", "none");
	            }, 200);
	        });
	    },
	    handleShop: function handleShop() {
	        $(".shopHeaderArea .shopInfo").bind("mouseenter", function () {
	            $(".ratLayer").css("display", "block").addClass("isIn");
	        }).bind("mouseleave", function () {
	            $(".ratLayer").removeClass("isIn");
	            setTimeout(function () {
	                if ($(".ratLayer").hasClass("isIn")) {
	                    return false;
	                }
	                $(".ratLayer").css("display", "none");
	            }, 200);
	        });
	
	        $(".ratLayer").bind("mouseenter", function () {
	            $(".ratLayer").addClass("isIn");
	        });
	
	        $(".ratLayer").bind("mouseleave", function () {
	            $(this).css("display", "none");
	        });
	    },
	    render: function render(data, tpl) {
	        var render = template.compile(tpl.tpl);
	        return render(data);
	    }
	};
	
	exports.handleNav = handleNav;
	exports.control = control;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	"use strict";
	
	var tpl = "\n    <div class=\"dd\" style=\"display: none;\">\n        <div class=\"dd-inner\">\n            <% for(i = 0; i < mainCategory.length; i ++) {%>\n            <div class=\"item\">\n                <h3>\n                    <i class=\"<%=mainCategory[i].directoryIconV2%>\"></i>\n                    <a <% if(mainCategory[i].linkText && mainCategory[i].linkText != \"javascript:;\") { %> class=\"link\" href=\"<%=mainCategory[i].linkText%>\" target=\"_blank\" <% } %>><%=mainCategory[i].text%></a>\n                    <% if(mainCategory[i].imgLogo && mainCategory[i].imgLogo != \"\") { %>\n                        <img src=\"<%=mainCategory[i].imgLogo%>\" class=\"cat-icon\">\n                    <% } %>\n                    <b class=\"arrow-right\"></b>\n                </h3>\n                <% if(mainCategory[i].mainTextLink) {%>\n                    <% for(j = 0; j < mainCategory[i].mainTextLink.length; j++) {%>\n                        <h4><a target=\"_blank\" href=\"<%=mainCategory[i].mainTextLink[j].linkText%>\"><%=mainCategory[i].mainTextLink[j].text%></a></h4>\n                    <%}%>\n                <%}%>\n                <div class=\"sub-menu\">\n                    <div class=\"sub-list\">\n                        <% if(mainCategory[i].popTwoCategory) { %>\n                            <% for(k=0; k<mainCategory[i].popTwoCategory.length; k++) { %>\n                                <dl class=\"slBlock\">\n                                    <dt class=\"liTitle\">\n                                        <a href=\"<%=mainCategory[i].popTwoCategory[k].linkText%>\" target=\"_blank\" clstag=\"firsttype|keycount|jdworldwidev2|fl<%=i+1%>-p<%=k+1%>\"><%=mainCategory[i].popTwoCategory[k].text%></a>\n                                    </dt>\n                                    <% if(mainCategory[i].popTwoCategory[k].popThreeCategory) { %>\n                                        <% for(l=0; l<mainCategory[i].popTwoCategory[k].popThreeCategory.length; l++) { %>\n                                            <dd class=\"liItem \">\n                                                <a href=\"<%=mainCategory[i].popTwoCategory[k].popThreeCategory[l].linkText%>\" target=\"_blank\" clstag=\"firsttype|keycount|jdworldwidev2|fl<%=i+1%>-p<%=k+1%>-<%=l+1%>\"><%=mainCategory[i].popTwoCategory[k].popThreeCategory[l].text%></a>\n                                            </dd>\n                                        <% } %>\n                                    <% } %>\n                                    <span class=\"clr\"></span>\n                                </dl>\n                                <% if(k != mainCategory[i].popTwoCategory.length-1) {%>\n                                    <div class=\"split\"></div>\n                                <% } %>\n                            <% } %>\n                        <% } %>\n                    </div>\n                    <div class=\"sub-right\">\n                        <% if(mainCategory[i].categoryRecommendBrand) { %>\n                            <div class=\"sr-mask <% if(mainCategory[i].categoryChannelLink || mainCategory[i].categoryRecommendBrand.length < 9) { %>normal<% } else { %>large<% } %>\"></div>\n                            <ul class=\"sub-brands clearfix\">\n                                <% for(j=0; j<mainCategory[i].categoryRecommendBrand.length; j++) { %>\n                                    <% if(mainCategory[i].categoryChannelLink) {%>\n                                        <% if(j < 8) { %>\n                                            <li>\n                                                <a href=\"<%=mainCategory[i].categoryRecommendBrand[j].linkText%>\" target=\"_blank\" clstag=\"firsttype|keycount|jdworldwidev2|fl<%=i+1%>-b<%=j+1%>\">\n                                                    <img src=\"//img11.360buyimg.com/cms/jfs/t2296/67/2540291745/1095/28285fbe/570e2074Nf22696dd.gif\" data-original=\"<%=mainCategory[i].categoryRecommendBrand[j].imgLogo%>\" class=\"lazy\">\n                                                </a>\n                                            </li>\n                                        <% } %>\n                                    <% } else { %>\n                                        <li>\n                                            <a href=\"<%=mainCategory[i].categoryRecommendBrand[j].linkText%>\" target=\"_blank\" clstag=\"firsttype|keycount|jdworldwidev2|fl<%=i+1%>-b<%=j+1%>\">\n                                                <img src=\"//img11.360buyimg.com/cms/jfs/t2296/67/2540291745/1095/28285fbe/570e2074Nf22696dd.gif\" data-original=\"<%=mainCategory[i].categoryRecommendBrand[j].imgLogo%>\" class=\"lazy\">\n                                            </a>\n                                        </li>\n                                    <% } %>\n                                <% } %>\n                            </ul>\n                            <ul class=\"sub-brands-link clearfix\">\n                                <% for(j=0; j<mainCategory[i].categoryRecommendBrand.length; j++) { %>\n                                    <% if(mainCategory[i].categoryChannelLink) {%>\n                                        <% if(j < 8) { %>\n                                            <li>\n                                                <a href=\"<%=mainCategory[i].categoryRecommendBrand[j].linkText%>\" target=\"_blank\" clstag=\"firsttype|keycount|jdworldwidev2|fl<%=i+1%>-b<%=j+1%>\"></a>\n                                            </li>\n                                        <% } %>\n                                    <% } else { %>\n                                        <li>\n                                            <a href=\"<%=mainCategory[i].categoryRecommendBrand[j].linkText%>\" target=\"_blank\" clstag=\"firsttype|keycount|jdworldwidev2|fl<%=i+1%>-b<%=j+1%>\"></a>\n                                        </li>\n                                    <% } %>\n                                <% } %>\n                            </ul>\n                        <% } %>\n                        <% if(mainCategory[i].categoryChannelLink) { %>\n                            <% for(j=0; j<mainCategory[i].categoryChannelLink.length; j++) { %>\n                                <a target=\"_blank\" href=\"<%=mainCategory[i].categoryChannelLink[0].linkText%>\">\n                                    <img src=\"//img11.360buyimg.com/cms/jfs/t2296/67/2540291745/1095/28285fbe/570e2074Nf22696dd.gif\" data-original=\"<%=mainCategory[i].categoryChannelLink[0].actImg%>\" class=\"sub-ad lazy\" clstag=\"firsttype|keycount|jdworldwidev2|fl<%=i+1%>-ad\">\n                                </a>\n                            <% } %>\n                        <% } %>\n                    </div>\n                </div>\n            </div>\n            <%}%>\n        </div>\n    </div>\n";
	exports.tpl = tpl;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	"use strict";
	
	var tpl = "\n<ul>\n    <% if(hnNavigationBar) { %>\n        <% for(i=0; i<hnNavigationBar.length; i++) { %>\n            <li clstag=\"firsttype|keycount|jdworldwide|nav<%=i+1%>\">\n                <a target=\"_blank\" class=\"rNav rNav-<%=hnNavigationBar[i].navId%>\" nav-idx=\"<%=hnNavigationBar[i].navIdx%>\" href=\"<%=hnNavigationBar[i].linkText%>\">\n                    <% if(hnNavigationBar[i].text && hnNavigationBar[i].text != \"\") { %>\n                        <%=hnNavigationBar[i].text%>\n                        <% if(hnNavigationBar[i].imgLogo) { %> \n                            <img src=\"<%=hnNavigationBar[i].imgLogo%>\" class=\"nav-icon\"> \n                        <% } %>\n                    <% } else { %>\n                        <img src=\"<%=hnNavigationBar[i].actImg%>\" class=\"nav-logo\">\n                    <% } %>\n                </a>\n            </li>\n        <% } %>\n    <% } %>\n</ul>\n";
	exports.tpl = tpl;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var tpl = '<% if(indexTopSearchKeyWords) { %>' + '<% for(i=0; i<indexTopSearchKeyWords.length; i++) { %>' + '<a href="<%=indexTopSearchKeyWords[i].linkText%>" target="_blank" class="style-red"><%=indexTopSearchKeyWords[i].text%></a>' + '<% } %>' + '<% } %>';
	    exports.tpl = tpl;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	
	    var originalColor = [];
	
	    function isPlaceholder() {
	        var input = document.createElement('input');
	        return 'placeholder' in input;
	    }
	
	    function changeToOriginalColor(self) {
	        var index = $(self).index();
	        var color = originalColor[$(self).index()];
	        $(self).css('color', color);
	    }
	
	    exports.init = function (defaultColor) {
	        defaultColor = defaultColor || "#666";
	        var texts = $(':text');
	        if (!isPlaceholder()) {
	            var len = texts.length;
	            for (var i = 0; i < len; i++) {
	                var self = texts[i];
	                var placeholder = $(self).attr('placeholder');
	                if ($(self).val() == "" && placeholder != null) {
	                    $(self).val(placeholder);
	                    originalColor[i] = $(self).css('color');
	                    $(self).css('color', defaultColor);
	                }
	            }
	        }
	
	        texts.focus(function () {
	            if ($(this).attr('placeholder') != null && $(this).val() == $(this).attr('placeholder')) {
	                $(this).val('');
	                changeToOriginalColor(this);
	            }
	        }).blur(function () {
	            if ($(this).attr('placeholder') != null && ($(this).val() == '' || $(this).val() == $(this).attr('placeholder')) && !$(this).hasClass("shutdown")) {
	                $(this).val($(this).attr('placeholder'));
	                $(this).css('color', defaultColor);
	            }
	        });
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var Config = __webpack_require__(3);
	
	    var search = function search() {};
	
	    search.prototype.addSearchEvent = function () {
	        $("#search-2014 .form button, #nav-mygb .form button").unbind("click").bind("click", function () {
	            var keyword = $(this).parent().find("input").attr("id");
	            doSearch(keyword);
	        });
	
	        $("#search-2014 .form input, #nav-mygb .form input").unbind("keydown").bind("keydown", function (event) {
	            if (event.keyCode == 13) {
	                doSearch($(this).attr("id"));
	            }
	        });
	    };
	
	    function doSearch(sNodeId) {
	        var sUrl,
	            sUrl_T = "//search.jd.com/Search?keyword={keyword}&enc={enc}{additional}";
	        var sAdditionalSearch = search.additinal || "";
	        var oKeyTextN = document.getElementById(sNodeId);
	        var sSelKeyValue = oKeyTextN.value;
	        sSelKeyValue = sSelKeyValue.replace(/^\s*(.*?)\s*$/, "$1");
	        if (sSelKeyValue.length > 100) {
	            sSelKeyValue = sSelKeyValue.substring(0, 100);
	        }
	        if ("" == sSelKeyValue) {
	            window.location.href = window.location.href;
	            return;
	        }
	        var iSearchType = 0;
	        if ("undefined" != typeof window.pageConfig && "undefined" != typeof window.pageConfig.searchType) {
	            iSearchType = window.pageConfig.searchType;
	        }
	        var sCIdParamKey_T = "&cid{level}={cid}";
	        var sCId = "string" == typeof search.cid ? search.cid : "";
	        var sCLevel = "string" == typeof search.cLevel ? search.cLevel : "";
	        var sEvVal = "string" == typeof search.ev_val ? search.ev_val : "";
	        switch (iSearchType) {
	            case 8:
	                sUrl_T = "//search.jd.hk/Search?keyword={keyword}&enc=utf-8";
	                break;
	            default:
	                break;
	        }
	        if ("string" == typeof sCId && "" != sCId && "string" == typeof sCLevel) {
	            var reLevel = /^(?:[1-8])?([1-3])$/;
	            if ("-1" == sCLevel) {
	                sCLevel = "";
	            } else {
	                if (reLevel.test(sCLevel)) {
	                    sCLevel = RegExp.$1;
	                } else {
	                    sCLevel = "";
	                }
	            }
	        }
	        sSelKeyValue = encodeURIComponent(sSelKeyValue);
	        sUrl = sUrl_T.replace(/\{keyword}/, sSelKeyValue);
	        sUrl = sUrl.replace(/\{enc}/, 'utf-8');
	        if (Config.isSubmited == false) {
	            setTimeout(function () {
	                Config.isSubmited = false;
	                window.location.href = sUrl;
	            }, 10);
	            Config.isSubmited = true;
	        }
	    }
	
	    module.exports = new search();
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    /**
	     * @获取用户信息并更新在顶栏个人信息
	     */
	    var setUserInfo = function setUserInfo(options) {
	        options = $.extend({
	            el: $("#new-ttbar-login"),
	            callback: null
	        }, options || {});
	
	        var getHttp = function getHttp() {
	            return 'https:' == document.location.protocol ? 'https://' : 'http://';
	        };
	
	        $.ajax({
	            url: getHttp() + "passport.jd.com/new/helloService.ashx", //接口人:穆永俊
	            dataType: "jsonp",
	            scriptCharset: "GBK",
	            success: function success(data) {
	                if (!data) {
	                    return false;
	                }
	
	                //更新顶栏个人信息
	                if (data.info) {
	                    var infoHk = data.info;
	                    if (data.info.indexOf("jd.com") > -1) {
	                        infoHk = data.info.replace(/home.jd.com/g, "home.jd.hk");
	                    }
	                    // 用全球购sso更换base中的login方法
	                    if (data.info.indexOf('login()') > -1) {
	                        infoHk = data.info.replace(/login\(\)/g, "newLogin()");
	                    }
	                    options.el.html(infoHk);
	                }
	                var _callback = function callback() {
	                    clearTimeout(timer);
	                    if ($.isFunction(options.callback)) {
	                        options.callback(data);
	                    }
	                    // 执行完一次后清空
	                    _callback = $.noop;
	                };
	                // 防止sso 有链接异常，造成callback不执行
	                var timer = setTimeout(function () {
	                    _callback();
	                }, 2000);
	
	                //更新其它域名cookies
	                if (data.sso) {
	                    var len = data.sso.length;
	                    $.each(data.sso, function (i, k) {
	                        $.getJSON(k).complete(function () {
	                            if (--len == 0) {
	                                _callback();
	                            }
	                        });
	                    });
	                } else {
	                    _callback();
	                }
	            }
	        });
	    };
	
	    module.exports = setUserInfo;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// /js/header.js